"use client";

import React from "react";
import { Facebook, Instagram, Twitter, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuLink } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems
  } = useMenu();
  const quickLinks = [{
    label: "Home",
    to: "/HomePage"
  }, {
    label: "How It Works",
    to: "/HowItWorksPage"
  }, {
    label: "Pickup Areas",
    to: "/ServiceAreasPage"
  }, {
    label: "FAQ",
    to: "/CommonQuestionsPage"
  }, {
    label: "Schedule Pickup",
    to: "/BookYourPickupPage",
    highlight: true
  }];
  return <NavigationMenu viewport={false} className="items-start justify-start">
      <NavigationMenuList className="flex-col items-start gap-4">
        {quickLinks.map((item, i) => <NavigationMenuItem key={item.label} data-index={i}>
            <NavigationMenuLink asChild className="p-0 bg-transparent hover:bg-transparent focus:bg-transparent hover:text-inherit focus:text-inherit h-auto w-auto">
              <Link to={item.to} className={`text-sm transition-colors hover:text-primary ${item.highlight ? "text-primary font-bold" : "text-sidebar-foreground"}`}>
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const serviceAreas = [{
    day: "Monday",
    area: "Kanata"
  }, {
    day: "Tuesday",
    area: "Nepean"
  }, {
    day: "Wednesday",
    area: "Downtown Ottawa"
  }];
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }];
  return <section id="footer" className="bg-sidebar text-sidebar-foreground pt-16 pb-8 border-t border-sidebar-border">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 mb-16">
          
          <div className="md:col-span-5 flex flex-col gap-6">
            <Link to="/" className="inline-block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623234/img/second_chance_threads_logo_footer.png" alt="Second Chance Threads" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sidebar-foreground/80 text-sm leading-relaxed max-w-md">
              Local Ottawa service. Free pickup. No hidden fees. Clothing donated to local charities. Providing a free, no-contact clothing pickup service across Ottawa. We sort and donate your gently used items to local charities, making giving easy while reducing community waste.
            </p>
          </div>

          <div className="md:col-span-3 flex flex-col gap-6">
            <h3 className="font-default font-semibold text-lg text-sidebar-foreground">
              Quick Links
            </h3>
            <MenuProvider menu_id="19" className="mb-4">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="md:col-span-4 flex flex-col gap-6">
            <h3 className="font-default font-semibold text-lg text-sidebar-foreground">
              Service Areas
            </h3>
            <ul className="space-y-4">
              {serviceAreas.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-sm">
                  <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                  <div>
                    <span className="block font-medium text-sidebar-foreground">
                      {item.day}
                    </span>
                    <span className="text-sidebar-foreground/80">
                      {item.area}
                    </span>
                  </div>
                </li>)}
            </ul>
          </div>

        </div>

        <div className="pt-8 border-t border-sidebar-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-sidebar-foreground/60 text-center md:text-left">
            © {currentYear} Second Chance Threads.ca. All rights reserved.
          </p>
          
          <div className="flex items-center gap-5">
            {socialLinks.map((item, i) => {
            const Icon = item.icon;
            return <Link key={i} data-index={i} to={item.href} className="text-sidebar-foreground/60 hover:text-sidebar-foreground transition-colors" aria-label={item.label}>
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>
        </div>
      </div>
    </section>;
}